import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormioCustomComponent } from "dp-formio";
import { Utils } from "formiojs";
import { CustomComponent } from "formiojs";
import { BehaviorSubject, Subject } from "rxjs";
import { Criterion, ReviewingEvaluationCustomOptionsType } from "./models";

@Component({
  selector: "app-reviewing-evaluation-wrapper",
  templateUrl: "./reviewing-evaluation-wrapper.component.html",
  // styleUrls: ['./reviewing-evaluation-wrapper.component.scss']
  encapsulation: ViewEncapsulation.None,
  providers: [],
})
export class ReviewingEvaluationWrapperComponent
  implements FormioCustomComponent<any>, OnDestroy, OnChanges
{
  destroy$ = new Subject<void>();
  @Input() data: Record<string, any>;
  @Input() customOptions: ReviewingEvaluationCustomOptionsType;
  @Input() formioComponent: CustomComponent;

  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() viewOnly: boolean;

  @Input() value: any;
  @Output() valueChange = new EventEmitter();

  private readonly _criterionsSub = new BehaviorSubject<Criterion[]>([]);
  criterions$ = this._criterionsSub.asObservable();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customOptions?.currentValue) {
      this.prepareData();
    }
  }
  updateValue() {
    const criterions = this._criterionsSub.value;
    let values = {
      data: criterions.map(({ key, totalEvaluation, notes }) => ({
        key,
        totalEvaluation,
        notes,
      })),
    };

    const isInvalidTotalEvaluation =
      this.required &&
      !criterions.every((criterion) =>
        criterion.subCriterions.every(
          (subCriterion) => subCriterion.totalEvaluation > 0
        )
      );

    if (isInvalidTotalEvaluation) {
      values = null;
    }

    this.value = values;
    this.valueChange.emit(values);
    this.updateBindedComponent();
  }

  private updateBindedComponent() {
    if (this.customOptions.bindWith) {
      const components = Utils.searchComponents(
        this.formioComponent.root.components,
        { key: this.customOptions.bindWith }
      );
      components.forEach((c) => {
        c.setValue(this.data[this.customOptions.bindWith]);
      });
      this.formioComponent?.currentForm?.triggerChange();
    }
  }
  private prepareData() {
    if (this.data[this.customOptions.bindWith]) {
      const data = this.data[this.customOptions.bindWith] as Criterion[];

      data.forEach((item) => {
        item.subCriterions.forEach((sub) => {
          sub.evaluation.forEach((evaluation) => {
            const from = +evaluation.fromRange;
            const to = +evaluation.toRange;

            evaluation.items = Array.from(
              { length: to - from + 1 },
              (_, index) => ({
                label: `${index + from}`,
                value: index + from,
              })
            );
          });
        });
      });

      this._criterionsSub.next(data);
      if (this.value) this.updateValue();
    }
  }
}
